module.exports = __webpack_public_path__ + "img/programs_spotlight.ad386bcf.png";